import axios from 'axios';

const configuredUrl = String(
  (typeof process !== 'undefined' && process.env && (process.env.REACT_APP_API_URL || process.env.VITE_API_URL)) || ''
).trim().replace(/\/$/, '');
const isLocal = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const API_URL = configuredUrl || (isLocal ? 'http://localhost:8081' : 'https://leotech-streaming.onrender.com');

axios.defaults.baseURL = API_URL;

axios.interceptors.request.use(config => {
  const hasUser = Boolean(localStorage.getItem('usuario'));
  const token = localStorage.getItem('token') || (hasUser ? sessionStorage.getItem('authToken') : '');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else {
    sessionStorage.removeItem('authToken');
    localStorage.removeItem('token');
  }
  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && window.location.pathname.startsWith('/admin')) {
      localStorage.removeItem('usuario');
      localStorage.removeItem('rol');
      localStorage.removeItem('token');
      sessionStorage.removeItem('authToken');
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export const NO_CACHE_HEADERS = {};

export const normalizeEliminado = item => {
  if (!item) return item;
  if (Array.isArray(item)) return item.map(normalizeEliminado);
  const eliminado = item.eliminado === true || item.eliminado === 'true' || Number(item.eliminado) === 1;
  return { ...item, eliminado: eliminado ? 1 : 0 };
};

export default API_URL;
